module.exports = __webpack_public_path__ + "static/media/sb.d64e9848.svg";